export default __webpack_public_path__ + "static/media/003-cut.eee60d6b.svg";